
import Vue from 'vue'
import * as Api from '@/api/SchoolApi'
import { SchoolSearchResultModel } from '@ViewModels/SchoolSearchResultModel'
import { Typeahead } from 'uiv'

export default Vue.extend({
   name: 'SchoolSearchFormGroup',
   props: {
      id: String,
      label: String,
      value: String,
      placeholder: { type: String, default: 'Start typing to search for your school' },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         searchText: '',
         searchResult: '',
         searching: false,
      }
   },
   methods: {
      async search(query: string, done: any) {
         try {
            if (query.length <= 3) {
               done([])
               return
            }
            this.searching = true
            const result: SchoolSearchResultModel[] = await Api.search(query)
            done(result)
            this.searching = false
         } catch (err) {
            this.searching = false
            done([])
            this.$emit('error', err.message)
         }
      },
      schoolSelected(school: SchoolSearchResultModel) {
         if (school && school.Id) {
            this.$emit('input', school)
         } else {
            this.$emit('attempt')
         }
      },
   },
   components: {
      Typeahead,
   },
})
